import { createFeature, createReducer, on } from '@ngrx/store';
import { MetaData, RetailerType } from '@emi/shared/models';
import * as retailerTypeActions from './retailer-type-actions';
import * as commonActions from '../common-actions';

export interface RetailerTypeState {
    retailerTypes: RetailerType[];
    metadata: MetaData | null;
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const retailerTypeFeatureKey = 'retailerTypeFilters';

const initialState: RetailerTypeState = {
    retailerTypes: [],
    metadata: null,
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const retailerTypeFeature = createFeature({
    name: retailerTypeFeatureKey,
    reducer: createReducer(
        initialState,
        on(retailerTypeActions.isLoadingRetailerTypes, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(retailerTypeActions.getNextPageRetailerTypes, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(retailerTypeActions.getRetailerTypesSuccess, (state, { retailerTypes, metadata, searchText }) => {
            return {
                ...state,
                retailerTypes,
                metadata,
                searchText,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(retailerTypeActions.updateRetailerTypesSelectionSuccess, (state, { retailers, metadata }) => {
            return {
                ...state,
                retailers: [...state.retailerTypes, ...retailers],
                metadata,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(retailerTypeActions.getRetailerTypesFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(retailerTypeActions.searchRetailerTypes, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
